import React,{useEffect} from "react";
import CardFile from "./CardFile";
import {Grid} from "@material-ui/core";
import {Typography,Box} from "@mui/material";
import {useDispatch,useSelector} from 'react-redux';
import{dailyIncome} from '../../../../redux/actions/PaymentActions';
import{getTodaysIncome}from '../../../../redux/actions/PaymentActionSaga'
import TodayIncome from "../TodayIncome";
export default function FinancialStatus(props) {
  const todayIncome=useSelector((state)=>state.payments.dailyIncome);
  const openTable = useSelector((state)=>state.payments.showTable)
   const dispatch=useDispatch();
  useEffect(()=>{
    dispatch(dailyIncome(props.buildingId));
  },[])
  return (
    <Box>
      <Grid container item spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant="h5" align="center" component="div">
            Financial Status
          </Typography>
        </Grid>{" "}
      </Grid>
      <Grid container spacing={3} justify="flex-start" sx={{backgroundColor:'#f3f5fa'}}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <CardFile title="TodayIncome" type="todayIncome" income={todayIncome} buildingId={props.buildingId} />
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          {openTable === true ? (<TodayIncome buildingId={props.buildingId}/>):(<></>)}
        </Grid>
      </Grid>
    </Box>
  );
}
